import { render, staticRenderFns } from "./bulk.vue?vue&type=template&id=2d625fc5&"
import script from "./bulk.vue?vue&type=script&lang=js&"
export * from "./bulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports